import { Subject } from 'rxjs';
import { Visualization } from '../../../../tamalelibs/models/tile.model';


export enum TileChooseEventType {
    tileTypeChange,
    tileDblClick
}

export class TileChooseConfig {
    config: Visualization;
    events$: Subject<{ type: TileChooseEventType, payload?: number }>;
    constructor() {
        this.config = new Visualization();
        this.events$ = new Subject();
    }
}

export interface Validatable {
    validate: () => boolean;
    refresh?: () => any;
}
